

<div class="device-infos" *ngIf="deviceDatas">
  <div>
    <p>Nom de l'appareil</p>
    <div class="deviceNameContainer">

      <h1>{{deviceDatas.deviceName}}</h1>
      <div id="editNameButton"  *ngIf="deviceDatas.uidDevice">
        <button (click)="editDeviceName()">
          <mat-icon>edit</mat-icon>
        </button>


      </div>
    </div>
    <p>Crée le  <b>{{deviceDatas.createdAt | date:'mediumDate'}}</b></p>


    <ng-container *ngIf="deviceDatas.uidDevice">
      <p>UID: <b>{{deviceDatas.uidDevice}}</b></p>
    </ng-container>

  </div>

  <div class="dateRange">

    <mat-form-field>
      <mat-label>Période</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDateRange">
        <input matEndDate [(ngModel)]="endDateRange">
      </mat-date-range-input>
      <mat-hint>JJ/MM/AAAA – JJ/MM/AAAA </mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker (closed)="setDateRange()"></mat-date-range-picker>
    </mat-form-field>
    <div (click)="resetDate()">
      <mat-icon>loop</mat-icon>
    </div>


  </div>


  <mat-card>
    <mat-card-subtitle>Nombre de sessions</mat-card-subtitle>
    <mat-card-title>{{deviceDatas.sessions}}</mat-card-title>
  </mat-card>
</div>




<mat-divider></mat-divider>
<p><b>Opérations</b></p>

<section class="operationButtonContainer">
  <div>
    <button mat-raised-button color="accent" (click)="refreshStats()">{{'refresh' | translation}}</button>
  </div>
  <div>
    <button [disabled]="disabledDelete" mat-raised-button color="warn" (click)="triggerStatsSuppression()">Supprimer toutes les statistiques de la borne</button>
  </div>
</section>
<mat-divider></mat-divider>
<section class="dataDisplay" *ngIf="deviceDatas && isMediaLicenceEnable">

  <div class="loading" *ngIf="isLoading">

    <img src="assets/ui/loading.svg"/>
  </div>

  <p><b>Liste des contenus</b></p>






  <table mat-table [dataSource]="deviceDatas.medias" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
    The actual rendered columns are set as a property on the row definition" -->
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Type de contenu </th>
      <td mat-cell *matCellDef="let element"> {{element.type}} </td>
    </ng-container>

    <!-- View number Column -->
    <ng-container matColumnDef="views">
      <th mat-header-cell *matHeaderCellDef> Nombre de vues </th>
      <td mat-cell *matCellDef="let element"> {{element.count}} </td>
    </ng-container>
    <!-- Lifecycle start Column -->
    <ng-container matColumnDef="lifecycleStart">
      <th mat-header-cell *matHeaderCellDef>Date de début d'affichage </th>
      <td mat-cell *matCellDef="let element"> {{element.lifecycle?.start}} </td>
    </ng-container>
    <!-- Lifecycle end Column -->
    <ng-container matColumnDef="lifecycleEnd">
      <th mat-header-cell *matHeaderCellDef> Date de fin d'affichage </th>
      <td mat-cell *matCellDef="let element"> {{element.lifecycle?.end}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td *matCellDef="let element">
        <button mat-button (click)="removeStat(element)"><mat-icon>delete</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="mediaContentTableColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: mediaContentTableColumns;"></tr>
  </table>



  <div class="chart" *ngIf="chartsData">

    <ngx-charts-bar-vertical [view]="view"
                             [scheme]="colorScheme"
                             [results]="chartsData"
                             [gradient]="gradient"
                             [xAxis]="showXAxis"
                             [yAxis]="showYAxis"
                             [showXAxisLabel]="showXAxisLabel"
                             [showYAxisLabel]="showYAxisLabel"
                             [yAxisLabel]="yAxisLabel"
                             legend=true>
    </ngx-charts-bar-vertical>

  </div>

</section>
